module.exports = __webpack_public_path__ + "media/Video 17.0875ee5d.mp4";